import React from 'react';
import SelectFieldCheckbox from './SelectFieldCheckbox';
import SegmentedToggle from '../../../SegmentedToggle';

const YES_NO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' },
];

export default class BoolField extends React.Component {
  static defaultProps = {
    value: null,
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
    IsCheckBoxEnabled: false,
    editedItem: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      selectValues: [],
    };
  }

  componentDidMount() {
    this.populateListData();
  }

  populateListData() {
    this.setState({
      selectValues: [
        { label: 'Choose one...', value: '', disabled: false },
        { label: 'Yes', value: true, disabled: false },
        { label: 'No', value: false, disabled: false },
      ],
    });
  }

  render() {
    // The On/Off-gated combo keeps its original dropdown-based control.
    if (this.props.IsCheckBoxEnabled) {
      return (
        <SelectFieldCheckbox
          value={this.props.value}
          className={this.props.className}
          selectValues={this.state.selectValues}
          fieldName={this.props.fieldName}
          onChange={this.props.onChange}
          IsCheckBoxEnabled={this.props.IsCheckBoxEnabled}
          editedItem={this.props.editedItem}
        />
      );
    }

    // Default: DS segmented Yes / No toggle. Value is a bit (true/false), or '' when
    // cleared via the eraser. String forms ('true'/'false') are tolerated defensively.
    const isYes = this.props.value === true || this.props.value === 'true';
    const isNo = this.props.value === false || this.props.value === 'false';

    return (
      <SegmentedToggle
        options={YES_NO_OPTIONS}
        value={isYes ? true : isNo ? false : null}
        onChange={(value) => this.props.onChange(this.props.fieldName, value)}
      />
    );
  }
}
